import Select from './Select.vue';
import SelectWithCheck from './SelectWithCheck.vue';
import SelectDescription from './SelectDescription.vue';

export const components = { Select, SelectWithCheck, SelectDescription };
